import sx from 'utils/createSx';

export default sx({
  container: {
    width: '100%',
    maxWidth: 1200,
    mx: 'auto',
    px: { xs: 1.5, sm: 2 },
    py: 2,
  },
  reportLayout: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  reportLayoutFooterPad: {
    pb: theme => theme.spacing(11),
  },
  stepNavRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 1,
    justifyContent: 'space-between',
  },
  tabpanel: {
    minHeight: 200,
  },
  suspenseFallback: {
    display: 'flex',
    justifyContent: 'center',
    py: 4,
  },
  editFooterWrap: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1100,
    display: 'flex',
    justifyContent: 'center',
    px: { xs: 1.5, sm: 2 },
    pt: 0,
    pointerEvents: 'none',
  },
  editFooterPaper: {
    pointerEvents: 'auto',
    width: '100%',
    maxWidth: 1200,
    py: 2,
    px: 2,
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: 2,
    borderRadius: '12px 12px 0 0',
    borderTop: 1,
    borderColor: 'divider',
  },
  tabs: { borderBottom: 1, borderColor: 'divider' },
  stepper: {
    display: { xs: 'none', md: 'flex' },
    '& .MuiStepLabel-label': { typography: 'caption' },
  },
});
